<template>
  <div class="lunbo">
    <Banner :swiperpic="swiperpic" :url="swiperurl"/>
    <Scroll @scrollBtn="scrollbtn" :scrollList="scrollList"/>
    <div class="notice-img">
      <div @click="picbtn(url.url1)"><img alt="我要捐赠" :src="middlepic1" /></div>
      <div @click="picbtn(url.url2)"><img alt="捐赠查询" :src="middlepic2" /></div>
      <div @click="picbtn(url.url3)"><img alt="募捐资格" :src="middlepic3" /></div>
    </div>
    
    <!-- 捐物公开，捐款公开，资金使用公开，物资发放公开 -->
    <div class="tabbar-group" style="overflow: hidden;margin-bottom: 20px;">
      <div style="display: inline-block;">
        <ul style="padding-left: 0px;width: 100%;display: flex;">
          <li @click="gotoDetail(index,item)" v-for="(item, index) in contentList" :key="index" class="title" :class="{ active: num == index }" @mouseover="onGetIdx(index)">
            {{ item.name }}
          </li>
        </ul>
        <el-table v-if="status == 1" :header-cell-style="getRowClass" :data="moneyIncome" style="width: 550px;padding-left: 0px;height: 300px;overflow-y: auto;overflow-x: hidden;">
          <el-table-column align="center" prop="donor" label="姓名"></el-table-column>
          <el-table-column align="center" prop="purpose" label="捐赠用途"></el-table-column>
          <el-table-column align="center" prop="money" label="捐赠金额"></el-table-column>
          <el-table-column align="center" prop="incomeTime" width="140" label="捐赠时间"></el-table-column>
        </el-table>
        <el-table v-if="status == 2" :header-cell-style="getRowClass" :data="goodsIncome" style="width: 550px;padding-left: 0px;height: 300px;overflow-y: auto;overflow-x: hidden;">
          <el-table-column align="center" prop="donor" label="捐赠人"></el-table-column>
          <el-table-column align="center" prop="goodsName" label="物价名称"></el-table-column>
          <el-table-column align="center" prop="money" label="总价"></el-table-column>
          <el-table-column align="center" prop="incomeTime" width="140" label="捐赠时间"></el-table-column>
        </el-table>
      </div>
      <div style="display: inline-block;margin-left: 80px;">
        <ul style="padding-left: 0px;width: 100%;display: flex;">
          <li  @click="gotoDetail1(index,item)" v-for="(item, index) in dataList" :key="index" class="title" :class="{ active1: num1 == index }" @mouseover="getTwo(index)">
            {{ item.name }}
          </li>
        </ul>
        <el-table v-if="status1 == 1" :header-cell-style="getRowClass" :data="moneyOut" style="width: 550px;padding-left: 0px;height: 300px;overflow-y: auto;overflow-x: hidden;">
          <el-table-column align="center" prop="purpose" label="支出事由"></el-table-column>
          <el-table-column align="center" prop="money" label="总价"></el-table-column>
          <el-table-column align="center" prop="outTime" label="支出时间"></el-table-column>
        </el-table>
        <el-table v-if="status1 == 2" :header-cell-style="getRowClass" :data="goodsOut" style="width: 550px;padding-left: 0px;height: 300px;overflow-y: auto;overflow-x: hidden;">
          <el-table-column align="center" prop="goodsName" label="物品名称"></el-table-column>
          <el-table-column align="center" prop="donee" label="接收单位"></el-table-column>
          <el-table-column align="center" prop="money" label="总价"></el-table-column>
        </el-table>
      </div>
      <!-- <tab-switch
        :dataList="contentList"
        style="margin-right: 10%"
      /> -->
      <!-- <tab-switch :dataList="dataList" /> -->
    </div>

    <!-- banner图 -->
    <div class="center-img">
      <div class="center-img_left">
        <img src="../../assets/image/title2.png" alt="">
      </div>
      <div class="center-img_right">
        <div v-for="(item,index) in bottompic" :key="index" @click="picbtn(item.path)">
          <img :src="item.img" alt="">
        </div>
      </div>
    </div>
    
    <!-- 文章模块 -->
    <div class="tabbar-group" style="overflow: hidden;margin-bottom: 20px;">
      <div style="display: inline-block;width: 585px;padding-right: 15px;">
        <ul  style="padding-left: 0px;width: 100%;height: 260px;overflow-y: auto;overflow-x: hidden;">
          <li v-for="(item, index) in threeList.slice(0,4)" :key="index + '-label'" class="title" :class="{ active: num2 == index }" @mouseover="getIndex(index)">
            {{ item.name }}
          </li>
          <li class="changeColor" style="cursor: pointer;width:1100px;height: 50px;line-height: 50px;position: relative;overflow:hidden" v-for="(itemOne,indexOne) in articleList" :key="indexOne" @click="goTo(itemOne.id)"><img class="image" style="margin-right: 10px;" src="../../assets/image/bit1.jpg" alt=""><span :title="itemOne.title" class="titleOne">{{ itemOne.title }}</span><span style="position: absolute;top:0;right: 568px;">{{ itemOne.createdTime }}</span></li>       
        </ul>
        <!-- <ul  v-for="(item1,index1) in threeList" :key="index1">
              <li  style="cursor: pointer;height: 50px;line-height: 50px;position: relative;" v-for="(itemOne,index2) in item1.articles" :key="index2" @click="goTo(itemOne.id)"><span>{{ itemOne.title }}</span><span style="position: absolute;right: 0;">{{ itemOne.createdTime }}</span></li>         
        </ul> -->
      </div>
      <div style="display: inline-block;width: 595px;">
        <ul  style="padding-left: 5px;width: 100%;height: 260px;overflow-y: auto;overflow-x: hidden;">
          <li v-for="(item, index) in threeList.slice(4,8)" :key="index + '-label'" class="title" :class="{ active: num3 == index+4 }" @mouseover="getIndexTow(index)">
            {{ item.name }}
          </li>
          <li class="changeColor" style="cursor: pointer;width:1100px;height: 50px;line-height: 50px;position: relative;overflow:hidden" v-for="(itemOne,indexOne) in articleListTwo" :key="indexOne" @click="goTo(itemOne.id)"><img class="image" style="margin-right: 10px;" src="../../assets/image/bit1.jpg" alt=""><span :title="itemOne.title" class="titleOne">{{ itemOne.title }}</span><span style="position: absolute;top:0;right: 535px;">{{ itemOne.createdTime }}</span></li>       
        </ul>
        <!-- <ul  v-for="(item1,index1) in threeList" :key="index1">
              <li  style="cursor: pointer;height: 50px;line-height: 50px;position: relative;" v-for="(itemOne,index2) in item1.articles" :key="index2" @click="goTo(itemOne.id)"><span>{{ itemOne.title }}</span><span style="position: absolute;right: 0;">{{ itemOne.createdTime }}</span></li>         
        </ul> -->
      </div>
    </div>

    <!-- 友情链接 -->
    <div>
      <div class="friendly-link">
        <div class="link_box_title">友情链接</div>
        <div class="link_box_list">
          <div class="link-type" v-for="(item, index) in organ" :key="index" @click="enter(item)" @mouseover="mouse(index)" @mouseout="mouse1" :class="{changecolor:index==mouseid}">
            {{ item.name }}
          </div>
        </div>
      </div>
      
      <!-- 链接 -->
      <div class="link-content link-content2" v-show="seen">
        <div class="close-link" @click="seen = !seen"></div>
        <link-list-two :formList="showOrgan"></link-list-two>
      </div>
    </div>

  </div>
</template>

<script>
// import LinkList from '@/components/LinkList.vue';
import Banner from "../../components/Banner.vue";
import Scroll from "../../components/Scroll.vue";
// import TabSwitch from "../../components/TabSwitch.vue";
import LinkListTwo from "@/components/LinkListTwo.vue";
export default {
  name: "First",
  components: { Banner, Scroll, LinkListTwo },
  data() {
    return {
      num: 0, // 默认索引值为0 即“捐款公开”为默认选中的选项卡
      num1: 0,
      num2:0,
      num3:0,
      moneyIncome: [],
      goodsIncome: [],
      moneyOut: [],
      goodsOut: [],
      dataList: [
        { id: 1, name: "资金使用公开" },
        { id: 2, name: "物资发放公开" },
      ],
      contentList: [
        { id: 1, name: "捐款公开" },
        { id: 2, name: "捐物公开" },
      ],
      threeList:[],
      articleList:[],
      articleListTwo:[],
      // linkList: ["总会及相关国际组织", "各省市红十字会", "州市红十字会"],
      seen: false,
      // 友情链接
      organ:[],
      // 链接显示
      showOrgan:[],
      // 图片
      // 图片合集
      swiperpic:[],
      middlepic1:'',
      middlepic2:'',
      middlepic3:'',
      // 底部三张图片集合数组
      bottompic:[],
      // bottompic:'',
      toppic:'',
      // 总图片合集
      picsList:[],
      // 滚动数据的集合
      scrollList:[],
      status: 1,
      status1: 1,
      status2:true,
      // 鼠标移上的索引
      mouseid:null,
      // 图片链接
      url:{
        url1:'',
        url2:'',
        url3:'',
      },
      // 轮播图图片链接
      swiperurl:[]
    };
  },
  created() {
    this.getOrganization();
    this.getMoneyIncome();
    this.getPics()
  },
  methods: {
    gotoDetail(index,item){
      if(index == 0 ){
        this.$router.push({
          path:'/contribution',
          query:{donate_name:item.name}
        })
      }else{
        this.$router.push({
          path:'/benevolence',
          query:{donate_name:item.name}
        })
      }
    },
    gotoDetail1(index,item){
      if(index == 0 ){
        this.$router.push({
          path:'/fund',
          query:{donate_name:item.name}
        })
      }else{
        this.$router.push({
          path:'/goods',
          query:{donate_name:item.name}
        })
      }
    },
    goTo(id){
      this.$router.push({
        path:'/maintext',
        query:{
          id:id
        }
      })
    },
    getRowClass({ rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#f5f5f5;border-bottom:0.5px solid #ccc;color:black";
      }
    },

    onGetIdx(idx) {
      this.num = idx;
      if (idx == 1) {
        this.status = 2;
      } else {
        this.status = 1;
      }
    },
    getTwo(idx) {
      this.num1 = idx;
      if (idx == 1) {
        this.status1 = 2;
      } else {
        this.status1 = 1;
      }
    },
    getIndex(idx){
      this.num2 = idx;
      this.articleList = this.threeList[idx].articles
    },
      getIndexTow(idx){
      idx = idx + 4;
      this.num3 = idx;
      this.articleListTwo = this.threeList[idx].articles
    },
    // 获取图片的函数
    async getPics(){
      const {data:res}=await this.$http.get('/index/siteInfo')
      if(res.code==200){
        this.picsList=res.data.pics
      }
      this.distributionpic(this.picsList)
    },
    // 分配图片的函数
    distributionpic(picsList){
      picsList.forEach(item => {
        switch (item.name){
          case '首页轮播图1':this.swiperpic.push(item.imgsrc),this.swiperurl.push(item.url)
          break;
          case '首页轮播图2':this.swiperpic.push(item.imgsrc),this.swiperurl.push(item.url)
          break;
          case '首页轮播图3':this.swiperpic.push(item.imgsrc),this.swiperurl.push(item.url)
          break;
          case '首页中间小图1':this.middlepic1=item.imgsrc,this.url.url1=item.url
          break;
          case '首页中间小图2':this.middlepic2=item.imgsrc,this.url.url2=item.url
          break;
          case '首页中间小图3':this.middlepic3=item.imgsrc,this.url.url3=item.url
          break;
          // case '首页底部长图':this.bottompic=item.imgsrc
          // break;
          case '首页底部小图1':this.bottompic.push({img:item.imgsrc,path:item.url})          
          break;
          case '首页底部小图2':this.bottompic.push({img:item.imgsrc,path:item.url})          
          break;
          case '首页底部小图3':this.bottompic.push({img:item.imgsrc,path:item.url})          
          break;
        }
      });
    },
    async getOrganization() {
      const { data: res } = await this.$http.get("/index/index");
      if (res.code == 200) {
        this.organ=res.data.links
        // 以下是首页的栏目数据与滚动数据
        // 滚动数据
        this.scrollList=res.data.notices
      }
      // this.getPics()
      // this.picsList=JSON.parse(window.sessionStorage.getItem('picsList'))
      // this.distributionpic(this.picsList)
    },
    // 滚动的组件触发的函数
    scrollbtn(i){
      this.$router.push({path:'/maintext',query:{id:i}})
    },
    getMoneyIncome() {
      this.$http.get("/index/index").then((res) => {
        // console.log(res.data.data.articles[0].moneyIncome)
        if (res.data.code === 200) {
          this.moneyIncome = res.data.data.articles[0].moneyIncome;
          this.goodsIncome = res.data.data.articles[0].goodsIncome;
          this.moneyOut = res.data.data.articles[0].moneyOut;
          this.goodsOut = res.data.data.articles[0].goodsOut;
          this.threeList = res.data.data.articles[0].articles
          //  res.data.data.articles[0].articles.forEach(list => {
          //   this.articleList = list
          //  });
          this.getIndex(this.num2);
          this.getIndexTow(this.num3)
        }
      });
    },
    // 点击友情链接触发的函数
    enter(item){
      this.seen=true
      this.showOrgan=item.sons
    },
    // 鼠标移入触发的函数
    mouse(index){
      this.mouseid=index
    },
    mouse1(){
      this.mouseid=0.1
    },
    // 点击图片跳转的函数
    picbtn(url){
      window.location.href=url
    }
  },
};
</script>

<style lang="less" scoped>
.notice-img {
  // a {
  //   margin-right: 20px;
  // }
  width: 100%;
  height: 113px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    width: 380px;
    height: 109px;
  }
}
.center-img {
  width: 100%;
  height: 130px;
  border: 1px solid hsl(0, 0%, 90%);
  padding: 14px;
  display: flex;
  box-sizing: border-box;
  .center-img_left{
    width: 76px;
    height: 100%;
    margin-right: 12px;
  }
  .center-img_right{
    flex:1;
    display: flex;
    justify-content: space-between;
    >div{
      width: 350px;
      height: 100%;
      background-color: red;
    }
  }
}
.tabbar-group {
  padding: 0;
  margin: 0;
}
.friendly-link {
  width: 100%;
  height: 67px;
  border-top: 2px solid #edebea;
  display: flex;
  .link_box_title {
    background: url(../../assets/image/bit2.jpg) left center no-repeat;
    width: 10%;
    text-align: center;
    height: 65px;
    line-height: 65px;
    // display: inline-block;
    // float: left;
    // margin-right: 100px;
    font-size: 18px;
    color: #d61d23;
    font-weight: bold;
  }
  .link_box_list {
    width: 90%;
    font-size: 16px;
    // display: inline-block;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 0 auto;
    .link-type {
      // display: inline-block;
      cursor: pointer;
      background: url(../../assets/image/bit3.jpg) right center no-repeat;
      // margin-right: 80px;
      padding-right: 20px;
      // padding-left: 120px;
      height: 65px;
      line-height: 65px;
      a {
        text-decoration: none;
        color: black;
      }
    }
  }
}
.link-content {
  z-index: 10;
  position: absolute;
  bottom: 250px;
  background: white;
  width:1200px;
    min-height: 80px;
    // height: auto!important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding: 20px 40px;
    box-sizing: border-box;
}
.close-link {
  width: 2%;
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  padding-top: 8px;
  text-align: right;
  float: right;
  cursor: pointer;
  background: url(../../assets/image/bit14.png) center right no-repeat;
}
img{
  width: 100%;
  height: 100%;
}
li {
  list-style: none;
}

// ul {
//   width: 100%;
//   display: flex;
// }

.title {
  float: left;
  text-align: center;
  height: 50px;
  font-weight: bold;
  padding: 0 20px;
  margin-right: 10px;
  line-height: 50px;
  font-size: 18px;
  cursor: pointer;
}

ol {
  color: gray;
  font-size: 14px;
  height: 250px;
  /* line-height: 250px; */
  cursor: default;
}

.active {
  background-color: #c10005;
  color: #fff;
}
.active1 {
  background-color: #c10005;
  color: #fff;
}
.content {
  display: none;
}

.con-active {
  display: block;
}
.image{
  width: 15px !important;
  height: 15px !important;
  margin-bottom: 18px;
}
.changeColor:hover{
  color: #b6283b;
}
.titleOne{
  display: inline-block;
  width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

}
.changecolor{
  color: red;
}

</style>